import type { Country, LabelKey, Labels } from "react-phone-number-input";

import { useTranslations } from "@ui/providers/useTranslations";

export const useCountryTranslations = (allowedCountries: Country[]) => {
  const { __ } = useTranslations();

  const customLabels: LabelKey[] = ["ZZ", "phone", "country", "ext"];

  const labels: LabelKey[] = [...allowedCountries, ...customLabels];

  const countryTranslations: Labels = labels.reduce<Labels>((acc, label) => {
    acc[label] = __("internationalPhone." + label);
    return acc;
  }, {});

  return countryTranslations;
};
